module.exports = "/images/ARISTEU_CARRIEL.jpg?4091eb0beda3f3205e76d8380f20e1a5";